/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Community_Mock_Time_AyseInputs */

const tr_landing_community_mock_time_ayse = /** @type {(inputs: Landing_Community_Mock_Time_AyseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2dk`)
};

const en_landing_community_mock_time_ayse = /** @type {(inputs: Landing_Community_Mock_Time_AyseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2m`)
};

const de_landing_community_mock_time_ayse = /** @type {(inputs: Landing_Community_Mock_Time_AyseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2 Min`)
};

const ru_landing_community_mock_time_ayse = /** @type {(inputs: Landing_Community_Mock_Time_AyseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2 мин`)
};

/**
* | output |
* | --- |
* | "2m" |
*
* @param {Landing_Community_Mock_Time_AyseInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_community_mock_time_ayse = /** @type {((inputs?: Landing_Community_Mock_Time_AyseInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Community_Mock_Time_AyseInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_community_mock_time_ayse(inputs)
	if (locale === "de") return de_landing_community_mock_time_ayse(inputs)
	if (locale === "ru") return ru_landing_community_mock_time_ayse(inputs)
	return tr_landing_community_mock_time_ayse(inputs)
});